import { writable } from "svelte/store";

export const page = writable(undefined);
export const params = writable(undefined);